import React from "react";

export default function PageWithSideBanners({ children }) {
  return (
    <div className="layoutShell">
      <aside className="sideBanner left">
        <a href="tel:+33630789320" aria-label="Appeler Alexis Thery - SAFTI">
          <img
            src="/ads/safti-banner.jpg"
            alt="Alexis Thery – Conseiller immobilier SAFTI – 06 30 78 93 20"
          />
        </a>
      </aside>

      <main className="mainContent">{children}</main>

      <aside className="sideBanner right">
        <a href="tel:+33630789320" aria-label="Appeler Alexis Thery - SAFTI">
          <img
            src="/ads/safti-banner.jpg"
            alt="Alexis Thery – Conseiller immobilier SAFTI – 06 30 78 93 20"
          />
        </a>
      </aside>
    </div>
  );
}
